module.exports = __webpack_public_path__ + "img/meetingIndex_ico01.1e9107cc.png";